import styled from "styled-components";
import C from "@assets/themes/colors";
import { CSSProperties } from "react";

export const Root = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 200;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.45);
  font-family: Roboto;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 822px;
  height: 729px;
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
  background-color: ${C.WHITE};
`

export const TopContent = styled.header`
  height: 96px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${C.LIGHTEST_GRAY};
`

export const TopDetails = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 6px 60px 0px;
`

export const Title = styled.span`
  font-size: 24px;
  color: ${C.BLACK};
  padding-left: 60px;
`

export const BlueTopDetail = styled.div`
  color: ${C.DARK_BLUE};
  font-size: 15px;
`

export const GrayTopDetail = styled.span`
  color: ${C.MID_GRAY};
  margin-left: 14px;
`

export const MiddleContent = styled.section`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px 0px;
`

export const MiddleRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 60px;
`

export const MiddleInput = styled.div`
  display: flex;
  flex-direction: column;
`

export const InputTitle = styled.span`
  font-size: 16px;
  padding-bottom: 16px;
  font-weight: bold;
  color: ${C.BLACK};
`

export const SelectorContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding: 15px 60px;
`

export const VerticalSelectorDivider = styled.div`
  width: 1px;
  height: calc(100% - 68px);
  background-color: ${C.GENERIC_GRAY};
  margin-top: 68px;
`

export const VerticalSelectorContainer = styled.div`
  max-width: 295px;
`

export const ComboboxContainer: CSSProperties = {
  width: '295px',
}

export const ComboboxTitle: CSSProperties = {
  color: C.BLACK,
  fontSize: '16px',
  fontWeight: 'bold',
  paddingBottom: '16px',
}

export const ComboboxOptionContainer: CSSProperties = {
  top: '125px',
}

export const AllAccessContainer = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
`

export const AllAccessCheckbox = styled.div`
  cursor: pointer;
  height: 21px;
  margin: 0px 20px 0px 40px;
`

export const AllAccessLabel = styled.span`
  color: ${C.DARK_GRAY};
`

export const ChipsContainer = styled.div`
  margin-top: 10px;
  max-height: 220px;
  overflow-y: auto;
`

export const BottomContent = styled.footer`
  display: flex;
  align-items: end;
  padding: 15px 60px;
`

export const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 45px;
`

export const Button: CSSProperties = {
  width: "140px",
  boxSizing: "border-box",
}

export const CancelButton = {
  ...Button,
  backgroundColor: "transparent", 
  border: `1px solid ${C.DARK_BLUE}`, 
  hoverBackgroundColor: `${C.DARK_BLUE}22`,
}

export const ConfirmButton = {
  ...Button,
  marginLeft: '15px',
  hoverBackgroundColor: `${C.DARK_BLUE}AA`,
}

export const LabelCancelButton: CSSProperties = {
  color: C.DARK_BLUE,
}
